import React from 'react'
import { css, cx } from '@emotion/css'
import { AttackEventServerTooltipContent } from './attack-event-server-tooltip-content'
import { ServerEnvironment } from '../../servers-grid/shared'
import {
  Tooltip,
  TooltipProps
} from '@contrast-security-inc/design-system-popovers'
import { Link } from '@contrast-security-inc/design-system-typography'
import { getServerDrilldownRoute } from '../../route'

interface ServerLinkWithTooltipProps {
  organizationUuid: string
  serverUuid: string
  serverName: string
  serverEnvironment: ServerEnvironment
  placement?: TooltipProps['placement']
  truncate?: boolean
}

export const ServerLinkWithTooltip: React.FC<ServerLinkWithTooltipProps> = ({
  organizationUuid,
  serverUuid,
  serverName,
  serverEnvironment,
  truncate,
  placement = 'top'
}) => {
  return (
    <Tooltip
      placement={placement}
      body={<AttackEventServerTooltipContent environment={serverEnvironment} />}
    >
      <Link
        font="body"
        className={cx(
          truncate &&
            css`
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-wrap: normal;
              padding-bottom: 1px;
              max-width: 250px;
            `
        )}
        href={getServerDrilldownRoute(organizationUuid, serverUuid)}
      >
        {serverName}
      </Link>
    </Tooltip>
  )
}
